import logo from 'src/images/logo-md.png';
import { Col, Row } from 'straightline-ui';
import { isFTL, PACKAGE_TYPES, PROJECT_44 } from 'straightline-utils/constants';
import { formatDate } from 'straightline-utils/time';

export function BillOfLading({ shipment, className = '', ...rest }) {
  return (
    <div className={`bol rounded bg-white p-4 ${className}`} {...rest}>
      <Row className="align-items-center">
        <Col xs="auto" className="mb-3">
          <h6 className="text-uppercase text-muted mb-1">Shipment</h6>
          <div>#{shipment.id}</div>
        </Col>
        <Col xs="auto" className="mb-3">
          <h6 className="text-uppercase text-muted mb-1">Shipper</h6>
          <div>{shipment.shipper.name}</div>
        </Col>
        <Col className="mb-3">
          <h6 className="text-uppercase text-muted mb-1">Reference Number</h6>
          <div>{shipment.reference_number || 'NA'}</div>
        </Col>
        <Col xs="auto" className="ml-auto mb-3">
          <img
            src={logo}
            alt="Straightline Logo"
            className="img-fluid"
            style={{ maxHeight: 26 }}
          />
        </Col>
      </Row>
      <hr className="mt-0 mb-3" />
      <Row>
        <Col sm="6" className="mb-3">
          <h6 className="text-uppercase text-muted mb-1">3rd Party Bill To</h6>
          <p className="mb-0">
            Straightsoft, Inc. dba Straightline
            <br />
            3750 Hacks Cross Rd, Suite 102-205 <br />
            Memphis, TN 38125 <br />
            (901) 295-8844 <br />
            accounting@bookstraightline.com
          </p>
        </Col>
        <Col sm="6" className="text-sm-right mb-3">
          <h6 className="text-uppercase text-muted mb-1">Carrier</h6>
          {shipment.carrier ? (
            <>
              <p className="mb-0">{shipment.carrier.name}</p>
              <p className="mb-0">
                {shipment.carrier.mc_number
                  ? `MC-${shipment.carrier.mc_number}`
                  : `MC Not Available`}
              </p>
              <p className="mb-0">
                {shipment.carrier.dot_number
                  ? `DOT-${shipment.carrier.dot_number}`
                  : `DOT Not Available`}
              </p>
              <p className="mb-0">
                {shipment.carrier.scac_code
                  ? `SCAC-${shipment.carrier.scac_code}`
                  : null}
              </p>
            </>
          ) : (
            <>
              <p className="mb-0 text-danger">Not Assigned</p>
            </>
          )}
          {isFTL(shipment) && (
            <div className="small text-danger">
              DO NOT load a carrier that does not <br />
              match the Carrier name & Driver information.
            </div>
          )}
        </Col>
      </Row>
      <hr className="mt-0 mb-3" />
      {isFTL(shipment) ? (
        <Row>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">Service</h6>
            {shipment.rate.service_level.name} (
            {shipment.rate.service_level.code})
          </Col>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">Driver</h6>
            {shipment.shipment_dispatch?.carrier_driver || 'NA'}
          </Col>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">Phone</h6>
            {shipment.shipment_dispatch?.carrier_phone || 'NA'}
          </Col>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">Truck</h6>
            {shipment.shipment_dispatch?.carrier_truck_number || 'NA'}
          </Col>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">Trailer</h6>
            {shipment.shipment_dispatch?.carrier_trailer_number || 'NA'}
          </Col>
        </Row>
      ) : (
        <Row>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">Service</h6>
            {shipment.rate.service_level.name} (
            {shipment.rate.service_level.code})
          </Col>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">PRO</h6>
            {shipment.shipment_dispatch?.carrier_pro_number || 'NA'}
          </Col>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">PICKUP</h6>
            {shipment.shipment_dispatch?.carrier_trailer_number || 'NA'}
          </Col>
          <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">Quote</h6>
            {shipment.shipment_dispatch?.carrier_rate_id || 'NA'}
          </Col>
          {/* <Col xs="auto" className="mb-3">
            <h6 className="text-uppercase text-muted mb-1">Account</h6>
            {shipment.carrier?.account_number || 'NA'}
          </Col> */}
        </Row>
      )}
      <hr className="mt-0 mb-3" />
      <Row>
        <Col sm="8">
          <Row>
            <Col sm="6" className="mb-3">
              <h6 className="text-uppercase text-muted mb-1">Pickup</h6>
              {shipment.pickup_address.name && (
                <div className="mb-0">{shipment.pickup_address.name}</div>
              )}
              <p className="mb-0">
                {shipment.pickup_address.address_1}
                {shipment.pickup_address.address_2
                  ? `, ${shipment.pickup_address.address_2}`
                  : ``}
              </p>
              <p className="mb-0">
                {shipment.pickup_address.city},&nbsp;
                {shipment.pickup_address.state}
                ,&nbsp;
                {shipment.pickup_address.postal_code}
              </p>
              <p className="mb-0">
                {formatDate(shipment.pickup_date, 'LLL do, yyyy')}
              </p>
              <p className="mb-0">{shipment.pickup_address.appointment}</p>
            </Col>
            <Col sm="6" className="mb-3 text-sm-right">
              <h6 className="text-uppercase text-muted mb-1">Pickup Contact</h6>
              <p className="mb-0">{shipment.pickup_address.contact}</p>
              <p className="mb-0">{shipment.pickup_address.phone}</p>
              <p className="mb-0 text-break">{shipment.pickup_address.email}</p>
            </Col>
          </Row>
          <hr className="mt-0 mb-3" />
          <Row>
            <Col sm="6" className="mb-3">
              <h6 className="text-uppercase text-muted mb-1">Delivery</h6>
              {shipment.delivery_address.name && (
                <p className="mb-0">{shipment.delivery_address.name}</p>
              )}
              <p className="mb-0">
                {shipment.delivery_address.address_1}
                {shipment.delivery_address.address_2
                  ? `, ${shipment.delivery_address.address_2}`
                  : ``}
              </p>
              <p className="mb-0">
                {shipment.delivery_address.city},&nbsp;
                {shipment.delivery_address.state}
                ,&nbsp;
                {shipment.delivery_address.postal_code}
              </p>
              <p className="mb-0">
                {formatDate(shipment.due_date, 'LLL do, yyyy')}
              </p>
              <p className="mb-0">{shipment.delivery_address.appointment}</p>
            </Col>
            <Col sm="6" className="mb-3 text-sm-right">
              <h6 className="text-uppercase text-muted mb-1">
                Delivery Contact
              </h6>
              <p className="mb-0">{shipment.delivery_address.contact}</p>
              <p className="mb-0">{shipment.delivery_address.phone}</p>
              <p className="mb-0 text-break">
                {shipment.delivery_address.email}
              </p>
            </Col>
          </Row>
        </Col>
        <Col sm="4" className="border-sm-left">
          <div className="">
            <h6 className="text-uppercase text-muted mb-1">Notes</h6>
            <p className="pre-line mb-0">{shipment.notes || 'NA'}</p>
          </div>
        </Col>
      </Row>
      <hr className="mt-0 mb-3" />
      <table className="w-100 table-nowrap table-responsive">
        <thead>
          <tr>
            <th className="pr-2">
              <h6 className="text-muted text-uppercase mb-1">Handling Units</h6>
            </th>
            <th className="px-2">
              <h6 className="text-muted text-uppercase mb-1">Dimensions</h6>
            </th>
            <th className="px-2">
              <h6 className="text-muted text-uppercase mb-1">Weight</h6>
            </th>
            <th className="px-2">
              <h6 className="text-muted text-uppercase mb-1">Class</h6>
            </th>
            <th className="pl-2">
              <h6 className="text-muted text-uppercase mb-1">Description</h6>
            </th>
          </tr>
        </thead>
        <tbody>
          {shipment.line_items.map((line_item, index) => {
            const packageType = PACKAGE_TYPES.find(
              (type) => type.value === line_item.type
            );

            return (
              <tr key={index}>
                <td className="pr-2">
                  {line_item.units} {packageType?.label}
                </td>
                <td className="px-2">
                  {line_item.length}x{line_item.width}x{line_item.height} in
                </td>
                <td className="px-2">
                  {line_item.total_weight.toLocaleString('en-US')} lbs
                </td>
                <td className="px-2">{line_item.freight_class}</td>
                <td className="pl-2">{line_item.description}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <hr className="my-3" />
      <table className="w-100 table-nowrap table-responsive">
        <thead>
          <tr>
            <th className="pr-2">
              <h6 className="text-muted text-uppercase mb-1">Accessorial</h6>
            </th>
            <th className="px-2">
              <h6 className="text-muted text-uppercase mb-1">Label</h6>
            </th>
            <th className="pl-2">
              <h6 className="text-muted text-uppercase mb-1">Description</h6>
            </th>
          </tr>
        </thead>
        <tbody>
          {!shipment.accessorial_codes && (
            <tr>
              <td className="pr-2">---</td>
              <td className="px-2">---</td>
              <td className="pl-2">---</td>
            </tr>
          )}
          {shipment.accessorial_codes?.map((code, index) => {
            let accessorialCode = PROJECT_44.ACCESSORIAL_CODES.find(
              ({ value }) => {
                return value === code;
              }
            );
            if (!accessorialCode) {
              accessorialCode = {
                value: code,
                label: 'Unknown Accessorial Code',
                description: 'NA'
              };
            }
            return (
              <tr key={index}>
                <td className="pr-2">{accessorialCode.value}</td>
                <td className="px-2">{accessorialCode.label}</td>
                <td className="pl-2">{accessorialCode.description || 'NA'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
